import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { usePrimaryEntity } from "../usePrimaryEntity";
import { OrganizationPreview } from "./OrganizationPreview/OrganizationPreview";
import { WorkspacePreview } from "./WorkspacePreview/WorkspacePreview";

export const ProductPreview: React.FC = () => {
    const activeOrganization = useActiveOrganization();
    const primaryEntity = usePrimaryEntity();

    if (activeOrganization) {
        return <OrganizationPreview />;
    }

    if (primaryEntity) {
        return <WorkspacePreview entity={primaryEntity} />;
    }

    return null;
};
